import {BigNumber} from "bignumber.js";

const HelperMixin = {
  methods: {
    /**
     * valueがnullの場合に空文字を返却する.
     * FormDataでパラメータを生成する際に利用.
     * @param value
     * @return {string|*}
     */
    nullToBlank (value) {
      return (value === null || value === undefined) ? '' : value
    },
    /**
     * 指定された値が空白（空の状態）であるかどうかを判定する
     * @param value
     * @return {boolean}
     */
    isBlank(value) {
      return value === undefined || value === null || value === false ||
        (typeof value === "object" && this.isPropertyEmpty(value)) ||
        (typeof value === "string" && value.trim().length === 0)
    },
    /**
     *
     * @param value
     * @return {boolean}
     */
    isNotBlank(value) {
      return !this.isBlank(value);
    },
    isPropertyEmpty (value) {
      for (const key in value) {
        return false
      }
      return true
    },

    /**
     * 指定された小数第何位で重量を四捨五入します。
     * （例: decimals=2 の場合、小数第3位を四捨五入して第2位まで残す）
     *
     * @param {number|string|BigNumber} value - 処理対象の重量
     * @param {number} [decimals=0] - 残したい小数点以下の桁数
     * @returns {string} 四捨五入された重量（精度を落とさないため文字列で返却）
     *
     * @example
     * roundHalfUp(1, 3)        // "1.0"
     * roundHalfUp(1.23, 3)     // "1.23"
     * roundHalfUp(1.9999, 3)   // "2.0"
     */
    roundHalfUp(value, decimals = 0) {
      // 数値でない場合はそのまま返す
      if (value == null || value === '' || isNaN(Number(value))) {
        return value;
      }
      // ROUND_HALF_UP: 一般的な四捨五入
      const roundStr = new BigNumber(value).toFixed(decimals, BigNumber.ROUND_HALF_UP);
      // return new BigNumber(roundStr).toString();
      return this.normalizeDecimalString(roundStr, decimals);
    },

    /**
     * 指定された小数第何位で重量を切り捨てます。
     *
     * @param {number|string|BigNumber} value - 処理対象の重量
     * @param {number} [decimals=0] - 残したい小数点以下の桁数
     * @returns {string} 切り捨てられた重量
     */
    roundFloor(value, decimals = 0) {
      // 数値でない場合はそのまま返す
      if (value == null || value === '' || isNaN(Number(value))) {
        return value;
      }
      // 1. まず指定桁数で切り捨てる（この時点では "1.500" のようにゼロが残る）
      const flooredStr = new BigNumber(value).toFixed(decimals, BigNumber.ROUND_FLOOR);
      return this.normalizeDecimalString(flooredStr, decimals);
    },

    /**
     * 指定された小数第何位で重量を切り上げます。
     *
     * @param {number|string|BigNumber} value - 処理対象の重量
     * @param {number} [decimals=0] - 残したい小数点以下の桁数
     * @returns {string} 切り上げられた重量
     */
    roundCeil(value, decimals = 0) {
      // 数値でない場合はそのまま返す
      if (value == null || value === '' || isNaN(Number(value))) {
        return value;
      }
      const ceilStr = new BigNumber(value).toFixed(decimals, BigNumber.ROUND_CEIL);
      return this.normalizeDecimalString(ceilStr, decimals);
    },

    /**
     * 小数部の不要な0を削除する。
     *
     * decimals > 0 の場合は小数点以下を最低1桁維持する。
     *
     * @param {number|string} value 対象値
     * @param {number} [decimals=0] 小数点以下桁数
     * @returns {string|*} 整形後の値
     *
     * @example
     * normalizeDecimalString('1.000', 3) // "1.0"
     * normalizeDecimalString('1.230', 3) // "1.23"
     * normalizeDecimalString('1.200', 3) // "1.2"
     * normalizeDecimalString('1', 0)     // "1"
     */
    normalizeDecimalString(value, decimals = 0) {
      // decimals = 0 の場合は整数化
      if (decimals === 0) {
        return value.replace(/\.0+$/, '');
      }

      const stringValue = String(value)
      if (!stringValue.includes('.')) {
        return stringValue
      }

      const [integerPart, decimalPart = ''] = stringValue.split('.')
      const trimmedDecimalPart = decimalPart.replace(/0+$/, '')

      // decimals > 0 の場合は小数部を最低1桁維持する
      if (trimmedDecimalPart.length === 0) {
        return `${integerPart}.0`
      }

      return `${integerPart}.${trimmedDecimalPart}`
    },

    /**
     * 工程の背景色を設定
     * @param member
     * @return {string}
     */
    levelBackgroundColor (member) {
      if (member.level === 1) {
        // 01工程
        return 'primary_level'
      } else if (member.level === 2) {
        // 02工程
        return 'secondary_level'
      } else if (member.level === 3) {
        // 03工程
        return 'tertiary_level'
      } else {
        // 04工程以降
        return 'quaternary_level'
      }
    },

    /**
     * パーセント文字列を数値に変換する
     * @param {string} percentStr - "80%" or "80" or 80
     * @return {number}
     */
    parsePercentToNumber (percentStr) {
      if (percentStr === null || percentStr === undefined || percentStr === '') {
        return 0
      }
      const stringValue = `${percentStr}`.replace('%', '').trim()
      return parseFloat(stringValue) || 0
    },

  }
}
export default HelperMixin
